import { Box, Dialog } from '@mui/material';
import React from 'react';

const style = {
  p: 4,
  borderRadius: '5px',
};

const WushModal = ({
  open, onClose, children,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
  >
    <Box sx={style}>
      {children}
    </Box>
  </Dialog>
);

export default WushModal;
